let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1RHPH")).then(() => parcelRequire('bA2bP'));